import React from "react";

function EditorElement(props) {
    return (<>
        {props.isActive ? (<>
                <div className={"canvas-content nopointer"}
                     onContextMenu={props.handleContextMenu}
                     onClick={props.handleCanvasOnClick}
                     onMouseMove={props.handleCanvasOnMouseMove}
                     onMouseOut={props.handleCanvasOnMouseOut}
                     onMouseDown={props.handleCanvasOnMouseDown}
                     onMouseUp={props.handleCanvasOnMouseUp}
                     onScroll={props.handleCanvasOnScroll}
                     onWheel={props.handleCanvasOnWheel}
                     onResizeCapture={props.handleResizeCap}
                >
                    <canvas ref={props.canvasRef} width={`${props.w}px`} height={`${props.h}px`}/>
                </div>
                <div ref={props.editableLayerRef} className={"editor-layer"}>
                    <svg transform="scale (1, -1)" transform-origin="center"
                         width={props.fieldSizeWidth}
                         height={props.fieldSizeHeight}>
                    </svg>
                </div>
                <div ref={props.bgRef} className={"editor-background dark"}
                     dangerouslySetInnerHTML={{__html: props.fileContent}}>
                </div>
            </>
        ) : (
            <>
                <div className={"canvas-content dark"}>
                    <canvas ref={props.canvasRef} width={`${props.w}px`} height={`${props.h}px`}/>
                </div>
                <div ref={props.bgRef} className={"editor-background"}>
                    <span>No item selected</span>
                </div>
                <div ref={props.editableLayerRef} className={"editor-layer"}></div>
            </>)
        }
    </>)
}

export default EditorElement